"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instructionNameBeet = exports.InstructionName = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
var InstructionName;
(function (InstructionName) {
    InstructionName[InstructionName["Unknown"] = 0] = "Unknown";
    InstructionName[InstructionName["MintV1"] = 1] = "MintV1";
    InstructionName[InstructionName["Redeem"] = 2] = "Redeem";
    InstructionName[InstructionName["CancelRedeem"] = 3] = "CancelRedeem";
    InstructionName[InstructionName["Transfer"] = 4] = "Transfer";
    InstructionName[InstructionName["Delegate"] = 5] = "Delegate";
    InstructionName[InstructionName["DecompressV1"] = 6] = "DecompressV1";
    InstructionName[InstructionName["Compress"] = 7] = "Compress";
    InstructionName[InstructionName["Burn"] = 8] = "Burn";
    InstructionName[InstructionName["CreateTree"] = 9] = "CreateTree";
    InstructionName[InstructionName["VerifyCreator"] = 10] = "VerifyCreator";
    InstructionName[InstructionName["UnverifyCreator"] = 11] = "UnverifyCreator";
    InstructionName[InstructionName["VerifyCollection"] = 12] = "VerifyCollection";
    InstructionName[InstructionName["UnverifyCollection"] = 13] = "UnverifyCollection";
    InstructionName[InstructionName["SetAndVerifyCollection"] = 14] = "SetAndVerifyCollection";
    InstructionName[InstructionName["MintToCollectionV1"] = 15] = "MintToCollectionV1";
})(InstructionName = exports.InstructionName || (exports.InstructionName = {}));
exports.instructionNameBeet = beet.fixedScalarEnum(InstructionName);
//# sourceMappingURL=InstructionName.js.map